export default __webpack_public_path__ + "assets/ico_block_ownership-906065fa.svg";